<template>
    <div class="max-w-5xl px-4 py-8 mx-auto">
      <router-link to="/aulas">
        <a @click="isOpenLogin = true"  href="javascript:void(0);" class="flex bg-white border border-gray-200 rounded-lg hover:border-gray-300 hover:ring-1 hover:ring-gray-200">
          <section class="p-6 bg-white rounded-lg">
            <div class="grid grid-cols-1 gap-12 sm:grid-cols-4 items-center ">
              <div class="flex items-center justify-center">  
                <img alt="Man" src="https://ensino.sbcp.org.br/view/layout/images/logo_sbcp_2.png"
                class="object-cover w-24 rounded-lg aspect-square flex items-center"
                />
              </div>

              <div class="sm:col-span-3 text-left">
                <p class="font-medium">
                  Projeto desenvolvido pela SBCP para aglutinar todas suas atividades cientíticas que possam contribuir para o ensino e atualização de seus associados
                </p>

                <span class="inline-flex items-center mt-8 not-italic">
                  <span class="hidden w-6 h-px bg-gray-400 sm:inline-block"></span>
                  <p class="text-sm text-gray-500 sm:ml-3">
                    <strong>SBCP</strong>, Sociedade Brasileira de Coloproctologia.
                  </p>
                </span>
              </div>
            </div>
          </section>
          </a>
        </router-link>
    </div>

</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<style scoped>

</style>
